import React, { useState } from 'react';
import {
	ApIcon,
	ApButtonSecondary,
	ApCheckbox,
	colors,
} from '@alixpartners/ui-components';
import {
	Wrapper,
	DropdownLabel,
	LabelText,
	Footer,
	List,
	ListItem,
	ListInfo,
	StyledMenu,
	CheckboxLabel,
} from './DpoFilter.styles';
import numeral from 'numeral';

export const DpoFilter = ({
	name = 'harmonized',
	options,
	onChange,
	selected,
}) => {
	const [isOpen, setOpen] = useState(false);

	const toggleMenu = open => {
		setOpen(open);
	};

	const handleChange = option => {
		let newSelected = [];

		if (selected.includes(option.value)) {
			newSelected = selected.filter(item => item !== option.value);
		} else {
			newSelected = [...selected, option.value];
		}

		onChange(newSelected);
	};

	const selectAll = () => {
		onChange(options.map(item => item.value));
	};

	const clear = () => {
		onChange([]);
	};

	const allLabel = `All ${name} Dpo`;
	const activeLabel =
		selected.length > 0 ? `${selected.length} ${name} Dpo` : allLabel;

	return (
		<StyledMenu
			button={
				<div style={{ width: 'fit-content' }}>
					<DropdownLabel isOpen={isOpen}>
						<LabelText>{activeLabel}</LabelText>
						<ApIcon iconName="caret" iconColor={colors.grey5} />
					</DropdownLabel>
				</div>
			}
			placement="bottom-end"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
		>
			<Wrapper>
				<List>
					{options.map(item => (
						<ListItem key={item.value} onClick={() => handleChange(item)}>
							<ApCheckbox
								onChange={() => {}}
								checked={selected.includes(item.value)}
							>
								<CheckboxLabel>{item.label}</CheckboxLabel>
							</ApCheckbox>
							{item.vendorsCount && (
								<ListInfo>
									{numeral(item.vendorsCount).format('0,0')} vendors
								</ListInfo>
							)}
						</ListItem>
					))}
				</List>

				<Footer>
					<ApButtonSecondary
						onClick={selectAll}
						disabled={selected.length === options.length}
						small
					>
						Select all
					</ApButtonSecondary>
					<ApButtonSecondary
						onClick={clear}
						disabled={selected.length === 0}
						small
					>
						Clear
					</ApButtonSecondary>
				</Footer>
			</Wrapper>
		</StyledMenu>
	);
};

export default DpoFilter;
